import React from 'react';

function InputControl(props) {
  return (
    <>
      {/* <div className="input-group form-floating-label fixed-label">
        <input type="text" name={props.name} placeholder={props.title} className="form-control" {...props} />
        <label className="asterisk-req">
          {props.title}
          {props.requiredField ? <span>*</span> : ""}
        </label>
        {props.charCount ? <div className="text-count">0/200</div> : null}
      </div> */}
      <div className="common-input-control">
        <p className="field-name">
          Product Number<span className="asterisk">*</span>
        </p>
        <input type="text" name="productNumber" placeholder="" className="form-control" />
      </div>
    </>
  );
}

export default InputControl;
